import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import s from './ItemList.scss';
export const ItemList = ({ items, title, boldTitle, size = 'small', }) => {
    return (React.createElement(Box, { gap: "SP3", className: s.container },
        React.createElement(Text, { className: classNames(boldTitle ? s.bold : s.semiBold), size: size }, title),
        items.map((item, idx) => (React.createElement(Box, { verticalAlign: "middle", gap: "SP1", key: idx.toString() },
            item.icon,
            React.createElement(Text, { className: classNames(boldTitle ? s.semiBold : s.bold), size: size }, item.text))))));
};
//# sourceMappingURL=ItemList.js.map